import {useState} from 'react';
import {Table, Avatar} from 'antd';
import {useQuery} from '@apollo/client';
import {DABA_ACADEMY_MEMBERS} from '../../home/SuperAdminOverview/resolvers';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  UserOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import styles from '../analytics.module.scss';
import UserLink from 'components/userLink/UserLink';

export const DabaAcademyMembersTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const {data, loading, refetch} = useQuery(DABA_ACADEMY_MEMBERS, {
    variables: {
      filters: {
        page: currentPage,
        limit: limit,
        paginate: true,
      },
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  });

  const handleTableChange = pagination => {
    setCurrentPage(pagination.current);
    setLimit(pagination.pageSize);
    refetch({
      filters: {
        page: pagination.current,
        limit: pagination.pageSize,
        paginate: true,
      },
    });
  };

  const columns = [
    {
      title: 'User Name',
      key: 'user',
      render: (_, record) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}>
          <Avatar icon={<UserOutlined />} />
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <span style={{fontWeight: 500, color: '#111827'}}>
              <UserLink userId={record?.user?.id}>
                {record?.user?.firstName} {record?.user?.lastName}
              </UserLink>
            </span>
            <span style={{fontSize: '12px', color: '#6b7280'}}>
              {record?.user?.email}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: 'Has Investments',
      key: 'hasInvested',
      align: 'center',
      render: (_, record) =>
        record?.hasInvested ? (
          <CheckCircleOutlined style={{color: '#52c41a', fontSize: '18px'}} />
        ) : (
          <CloseCircleOutlined style={{color: '#d9d9d9', fontSize: '18px'}} />
        ),
    },
    {
      title: 'Last Investment',
      key: 'lastInvestmentDate',
      align: 'center',
      render: (_, record) =>
        record?.lastInvestmentDate ? (
          <span>
            {moment(record?.lastInvestmentDate).format('MMM DD, YYYY')}
          </span>
        ) : (
          '--'
        ),
    },
    {
      title: 'Purchase Date',
      key: 'purchaseDate',
      render: (_, record) => (
        <span>
          {record?.purchaseDate
            ? moment(record.purchaseDate).format('MMM DD, YYYY')
            : 'N/A'}
        </span>
      ),
    },
    {
      title: 'Last Investment Date',
      key: 'lastInvestmentDate',
      render: (_, record) => (
        <span>
          {record?.lastInvestmentDate
            ? moment(record.lastInvestmentDate).format('MMM DD, YYYY')
            : 'N/A'}
        </span>
      ),
    },
    {
      title: 'Last Active',
      key: 'lastActive',
      render: (_, record) =>
        record?.user?.currentSessionDetails?.currentDateTime
          ? moment(record.user.currentSessionDetails.currentDateTime).format(
              'DD, MMM YYYY. hh:mm A',
            )
          : '-',
    },
    {
      title: 'Has Portfolio',
      key: 'hasPortfolio',
      render: (_, record) =>
        record?.hasPortfolio ? (
          <CheckCircleOutlined style={{color: '#52c41a', fontSize: '18px'}} />
        ) : (
          <CloseCircleOutlined style={{color: '#d9d9d9', fontSize: '18px'}} />
        ),
    },
  ];

  const dataSource = data?.getDabaAcademyMembers?.data || [];
  const paginationData = data?.getDabaAcademyMembers?.pagination || {};

  return (
    <div className={styles.membersTableContainer}>
      <div className={styles.membersHeader}>
        <h3 className={styles.sectionTitle}>Daba Academy Members</h3>
      </div>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        rowKey={record => record?.user?.id || Math.random()}
        pagination={{
          current: currentPage,
          pageSize: limit,
          total: paginationData.total || 0,
          showSizeChanger: true,
          position: ['bottomRight'],
        }}
        onChange={handleTableChange}
        className="antd-table"
      />
    </div>
  );
};
